<template>
  <div class="app_cp">
    <div class="register" v-if="isRegister">
      <div class="register-form">
        <el-form ref="ruleFormRef" :model="form" label-width="auto" style="max-width: 600px" :rules="rules">
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入用户名">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 40px" label="密码" prop="password">
            <el-input v-model="form.password" placeholder="请输入密码" type="password">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 40px" label="确认密码" prop="confirm">
            <el-input v-model="form.confirm" placeholder="请输入密码" type="password">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 40px" label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入密码">
            </el-input>
          </el-form-item>
          <el-form-item label=" " style="margin-top: 40px">
            <div class="btn" @click="registerSubmit(ruleFormRef)">提交</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'

const router = useRouter()
const ruleFormRef = ref()
const form = reactive({
  userName: '',
  password: '',
  confirm: '',
  phone: ''
})
const isRegister = ref(true)
const rules = ref({
  userName: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
  ],
  confirm: [
    { required: true, message: '请确认密码', trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
  ]
})
const registerSubmit = async (formEl) => {
  await formEl.validate((valid) => {
    if (valid) {
      if (form.password !== form.confirm) {
        ElMessage({
          message: '两次输入的密码不一致，请重新输入',
          type: 'warning',
        })
        return
      }
      const users = JSON.parse(localStorage.getItem('users')) || []
      users.push({
        name: form.userName,
        password: form.password,
        phone: form.phone,
      });
      localStorage.setItem('users', JSON.stringify(users));
      ElMessage({
        message: '注册成功',
        type: 'info',
      })
      router.push('/index')
    }
  })
}
const goBack = () => {
  router.push('/')
}
</script>

<style scoped lang="less">
.app_cp {
  width: 100%;
  height: 100%;
  .register {
    background: url('@/assets/login/regist_bg.jpg') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .register-form {
    width: 827px;
    height: 497px;
    background: #FFFFFF;
    box-shadow: 1px 1px 20px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    padding: 74px 228px 73px 228px;
    box-sizing: border-box;
  }

  .btn {
    width: 291px;
    height: 41px;
    background: #1AB580;
    box-shadow: 1px 1px 8px 0px rgba(0, 87, 246, 0.4);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .pay {
    background: url('@/assets/login/pay.jpg') no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .goback {
      margin-top: 370px;
      margin-left: 680px;
      width: 80px;
      height: 41px;
      font-weight: bold;
      font-size: 20px;
      color: #1AB580;
      cursor: pointer;
    }
  }
}
</style>
